import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb, Col, Row, Space, Spin } from 'antd'

import { UpdateDataText } from '../../../core/components/sections'

import { HistoryLink } from '../../../common/components/sections'
import { StyledPageSubTitle } from '../../../common/components/styled'
import { APP_ROUTES, EVENT_METADATA_TYPES } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks'

import { renderIngredientCommonNegativeSynonymEvent } from '../../helpers'
import { useIngredientCommonNegativeSynonymPhrasesQuery } from '../../hooks'
import { IngredientCommonNegativeSynonymPhrasesForm } from '../forms'

const IngredientCommonNegativeSynonymsPage = () => {
  useDocumentTitle('Ingredient Common Negative Synonym Phrases')

  const {
    isLoading: isFetchLoading,
    error: fetchError,
    data,
    latestEvent,
  } = useIngredientCommonNegativeSynonymPhrasesQuery()

  useEffect(() => {
    if (fetchError?.message) {
      showErrorNotification({
        title: 'Ingredient Common Negative Synonym Phrases error',
        description: fetchError.message,
      })
    }
  }, [fetchError])

  return isFetchLoading ? (
    <Spin />
  ) : (
    <>
      <StyledPageSubTitle>
        <Row justify="space-between">
          <Col span={12}>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={APP_ROUTES.INGREDIENTS.link}>
                  {APP_ROUTES.INGREDIENTS.name}
                </Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>
                <Link
                  to={
                    APP_ROUTES.INGREDIENTS.subMenuItems
                      .INGREDIENT_COMMON_NEGATIVE_SYNONYMS.link
                  }
                >
                  {
                    APP_ROUTES.INGREDIENTS.subMenuItems
                      .INGREDIENT_COMMON_NEGATIVE_SYNONYMS.name
                  }
                </Link>
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>

          <Space>
            <UpdateDataText
              updatedAt={latestEvent?.createdAt}
              updatedBy={latestEvent?.createdBy?.name}
            />
            <HistoryLink
              filterEventTypes
              renderEvent={renderIngredientCommonNegativeSynonymEvent}
              eventMetadataTypes={[
                EVENT_METADATA_TYPES.INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE,
              ]}
            />
          </Space>
        </Row>
      </StyledPageSubTitle>
      <IngredientCommonNegativeSynonymPhrasesForm
        ingredientCommonNegativeSynonymPhrases={data}
      />
    </>
  )
}

export default IngredientCommonNegativeSynonymsPage
